<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("centers.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="centerFilter"
          :options="centerOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:centerFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("sectors.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectorOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    centerOptions: {
      type: Array,
      default: null,
    },
    centerFilter: {
      type: Array,
      default: null,
    },
    sectorOptions: {
      type: Array,
      default: null,
    },
    sectorFilter: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
